import script from "./pc-module-complex-table-1.vue?vue&type=script&setup=true&lang=tsx"
export * from "./pc-module-complex-table-1.vue?vue&type=script&setup=true&lang=tsx"

import "./pc-module-complex-table-1.vue?vue&type=style&index=0&id=14099760&lang=scss"

const __exports__ = script;

export default __exports__